import React,{useState, useContext, useRef, useEffect} from 'react'
import { GlobalContext } from '../../../context/provider';
import customerloanreportaction from '../../../context/action/report/customerloanreportaction';
import Mizania_customer_loan_table from './mizania_customer_loan/mizania_customer_loan_table';
import companyloanreportaction from '../../../context/action/report/companyloanreportaction';
import Mizania_company_loan_table from './mizania_company_loan/mizania_company_loan_table';
import get_customer_loanaction from '../../../context/action/mizania/get_customer_loanaction';
import get_company_loanaction from '../../../context/action/mizania/get_company_loanaction';
import Mizania_table from './mizania_table';
import final_mizaniaaction from '../../../context/action/mizania/final_mizaniaaction';
import statment_of_currentaction from '../../../context/action/mizania/statment_of_currentaction';
import Statment_of_current_table from './statment_of_current_table';

const Report_Mizania = () => {
    const { initState, initDispatch, clear } = useContext(GlobalContext);

    const [error, seterror] = useState(false);
    const [error1, seterror1] = useState(false);

    // الميزانية العامة
    const [total_previous_warehouse_price, settotal_previous_warehouse_price]=useState(0);
    const [total_warehouse_price, settotal_warehouse_price]=useState(0);
    const [total_previous_loan_sold, settotal_previous_loan_sold]=useState(0);
    const [total_loan_sold, settotal_loan_sold]=useState(0);
    const [total_previous_loan_bought, settotal_previous_loan_bought]=useState(0);
    const [total_loan_bought, settotal_loan_bought]=useState(0);
    const [assets, setassets]=useState([]);
    const [fixed_assets, setfixed_assets]=useState([]);
    const [current_assets, setcurrent_assets]=useState([]);
    const [funding_sources, setfunding_sources]=useState([]);
    const [current_liabilities, setcurrent_liabilities]=useState([]);

    // كشف العمليات الجارية
    const [current_statment, setcurrent_statment]=useState({});


    return (
      <div className="min-h-screen bg-slate-50 p-6 md:p-8">
          {/* Page Header */}
          <div className="flex items-center justify-between mb-8">
              <div>
                <h1 className="text-2xl font-bold text-slate-800">ڕاپۆرت ← میزانییە</h1>
                <p className="text-sm text-slate-400 mt-0.5">-</p>
              </div>
          </div>
          <div className="bg-white border border-slate-100 rounded-xl p-6 mb-6 shadow-sm">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-4 items-end">
              <div className="w-full">
                  <label
                      className={
                          error
                          ? "block text-sm font-medium text-red-500 mb-1 text-right"
                          : "block text-sm font-medium text-slate-500 mb-1 text-right"
                      }
                      for="from"
                  >
                      ساڵ{" "}
                  </label>
                  <select
                      className={
                        error
                            ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                            : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                      }
                      id="mizania_date"
                      value={initState?.mizania_form_date}
                      onChange={(val) => initDispatch({ type: 'setmizania_form_date', payload: val.target.value })}
                      onFocus={() => seterror(false)}
                  >
                      <option value="" disabled>--</option>
                      {Array.from({ length: 15 }, (_, i) => new Date().getFullYear() - i).map((y) => (
                      <option key={y} value={y}>{y}</option>
                      ))}
                  </select>
              </div>
            </div>
          </div>
          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4 sm:gap-6">
              {/* Add your existing report cards here with updated styling */}
              {/* Example of one card: */}
              <div
                  className="cursor-pointer rounded-lg bg-white shadow-md 
                  transition-all duration-200 hover:shadow-lg"
                  onClick={()=>{
                    if(initState?.mizania_form_date==""){
                      seterror(true);
                      return;
                    }
                    get_customer_loanaction(initState?.mizania_form_date)(initDispatch)(clear);
                  }}
              >
                  <div className="p-4 sm:p-6">
                    <h5 className="mb-2 text-lg sm:text-xl font-medium text-gray-900">
                        لیستی قەرزی کڕیار
                    </h5>
                    <div className="pt-4 border-t text-sm text-gray-600">
                        -
                    </div>
                  </div>
              </div>
              <div
                  className="cursor-pointer rounded-lg bg-white shadow-md 
                  transition-all duration-200 hover:shadow-lg"
                  onClick={()=>{
                    if(initState?.mizania_form_date==""){
                      seterror(true);
                      return;
                    }
                    get_company_loanaction(initState?.mizania_form_date)(initDispatch)(clear);
                  }}
              >
                  <div className="p-4 sm:p-6">
                    <h5 className="mb-2 text-lg sm:text-xl font-medium text-gray-900">
                        لیستی قەرزی کۆمپانیا
                    </h5>
                    <div className="pt-4 border-t text-sm text-gray-600">
                        -
                    </div>
                  </div>
              </div>
          </div>
          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4 sm:gap-6">
              <div
                  className="cursor-pointer rounded-lg bg-white shadow-md 
                  transition-all duration-200 hover:shadow-lg"
                  onClick={()=>{
                    if(initState?.mizania_form_date==""){
                      seterror(true);
                      return;
                    }
                    final_mizaniaaction(initState?.mizania_form_date)(clear).then((res)=>{
                        if(res?.status=="ok"){
                            settotal_previous_warehouse_price(res?.total_previous_warehouse_price);
                            settotal_warehouse_price(res?.total_warehouse_price);
                            settotal_previous_loan_sold(res?.total_previous_loan_sold);
                            settotal_loan_sold(res?.total_loan_sold);
                            settotal_previous_loan_bought(res?.total_previous_loan_bought);
                            settotal_loan_bought(res?.total_loan_bought);
                            setassets(res?.mizania?.filter((item)=>item?.mizania_category=="الموجودات"));
                            setfixed_assets(res?.mizania?.filter((item)=>item?.mizania_category=="الموجودات الثابتة"));
                            setcurrent_assets(res?.mizania?.filter((item)=>item?.mizania_category=="الموجودات المتداولة"));
                            setfunding_sources(res?.mizania?.filter((item)=>item?.mizania_category=="مصادر التمويل"));
                            setcurrent_liabilities(res?.mizania?.filter((item)=>item?.mizania_category=="المطلوبات المتداولة"));
                            initDispatch({ type: 'setmizania_form_table_type', payload: "final_mizania_report" });
                        }   
                    })
                  }}
              >
                  <div className="p-4 sm:p-6">
                  <h5 className="mb-2 text-lg sm:text-xl font-medium text-gray-900">
                      الميزانية العامة
                  </h5>
                  <div className="pt-4 border-t text-sm text-gray-600">
                      -
                  </div>
                  </div>
              </div>
              <div
                  className="cursor-pointer rounded-lg bg-white shadow-md 
                  transition-all duration-200 hover:shadow-lg"
                  onClick={()=>{
                    if(initState?.mizania_form_date==""){
                      seterror(true);
                      return;
                    }
                    statment_of_currentaction(initState?.mizania_form_date)(clear).then((res)=>{
                        setcurrent_statment(res); 
                        initDispatch({ type: 'setmizania_form_table_type', payload: "statment_of_current_report" });
                    })
                  }}
              >
                  <div className="p-4 sm:p-6">
                  <h5 className="mb-2 text-lg sm:text-xl font-medium text-gray-900">
                      كشف العمليات الجارية
                  </h5>
                  <div className="pt-4 border-t text-sm text-gray-600">
                      -
                  </div>
                  </div>
              </div>
          </div>
          {
            initState?.mizania_form_table_type == "customer_loan_report"?
            <Mizania_customer_loan_table data={initState?.mizania_form_ddata} mizania_date={initState?.mizania_form_date} />:
            initState?.mizania_form_table_type === "company_loan_report"?
            <Mizania_company_loan_table data={initState?.mizania_form_ddata} mizania_date={initState?.mizania_form_date} />:
            initState?.mizania_form_table_type == "final_mizania_report"?
            <Mizania_table mizania_date={initState?.mizania_form_date} total_previous_warehouse_price={total_previous_warehouse_price} total_warehouse_price={total_warehouse_price} total_previous_loan_sold={total_previous_loan_sold} total_loan_sold={total_loan_sold} total_previous_loan_bought={total_previous_loan_bought} total_loan_bought={total_loan_bought} assets={assets} fixed_assets={fixed_assets} current_assets={current_assets} funding_sources={funding_sources} current_liabilities={current_liabilities} />:
            initState?.mizania_form_table_type== "statment_of_current_report"?
            <Statment_of_current_table mizania_date={initState?.mizania_form_date} {...current_statment} />:
            null
          }
      </div>
    )
}

export default Report_Mizania